




import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Record } from '@/domains/work';
import { Load } from '@/domains/system';
import { Page } from '@/domains/page';
import { listRecordApi } from '@/api/work/RecordApi';
import { isNullOrUndefined } from 'util';

import { export_json_to_excel } from '@/vendor/Export2Excel';

@Component
export default class RecordExportExcelButton extends Vue {
  /** 表头 */
  // private static HEADERS: string[] = [
  //   '档案编号', '计划编号', '用时', 'ip', '来源', '校区', '周', '星期', '节次', '课程名',
  //   '课程号', '教学班号', '教师姓名', '教师职称', '开课单位', '档案状态', '督导组别', '督导姓名',
  //   '督导学科', '教师优先', '课程优先', '听课类型', '提交时间',
  // ];
  private static HEADERS: string[] = [
    '档案编号', '计划编号', '校区', '周', '星期', '节次', '课程名',
    '课程号', '教学班号', '年级', '教师姓名', '教师职称', '开课单位', '档案状态', '督导组别', '督导姓名',
    '督导学科', '教师优先', '课程优先', '听课类型', '提交时间', '用时', 'ip', '来源',
  ];

  /** 导出 */
  private static export(datas: Record[]) {
    Load.startFullLoad('正在导出督导列表');
    const excelList: any[] = RecordExportExcelButton.convertExcelData(datas);
    export_json_to_excel({
      header: RecordExportExcelButton.HEADERS,
      data: excelList,
      filename: '听课记录列表' + new Date().getTime(),
      autoWidth: true,
    });
    Load.stopFullLoad();
  }

  /** 转换 Excel 数据 */
  private static convertExcelData(datas: Record[]) {
    const list: any[] = [];
    datas.forEach((data: Record) => {
      const temp: any[] = [];
      temp.push(data.id);
      temp.push(data.plan.id);

      temp.push(data.plan.coursePlan.campus.name);
      temp.push(data.weeks);
      temp.push(data.week);
      temp.push(data.classes);
      temp.push(data.plan.coursePlan.clazz.course.name);
      temp.push(data.plan.coursePlan.clazz.course.id);
      temp.push(data.plan.coursePlan.clazz.id);
      temp.push(data.plan.coursePlan.clazz.grade);
      temp.push(data.plan.coursePlan.teacher.name);
      temp.push(data.plan.coursePlan.teacher.profession.name);
      temp.push(data.plan.coursePlan.clazz.department.name);
      temp.push(data.statusValue);
      temp.push(data.plan.supervisor.supervisorGroup.fullName);
      temp.push(data.plan.supervisor.person.name);
      temp.push(data.plan.supervisor.courseGroup.name);
      temp.push(data.plan.coursePlan.teacher.priority.priorityOption.name);
      temp.push(data.plan.coursePlan.clazz.priority.priorityOption.name);
      temp.push(data.plan.listenTypeName);
      temp.push(data.confirmTimeFormat);

      temp.push(data.useTime);
      temp.push(data.ip);
      temp.push(data.source);
      list.push(temp);
    });
    return list;
  }

  /** 计划 */
  @Prop()
  private form: Record;

  @Prop()
  private datas: Record[];

  /** 点击 */
  private click() {
    if (!isNullOrUndefined(this.datas) && this.datas.length > 0) {
      RecordExportExcelButton.export(this.datas);
    } else {
      this.search().then((datas: Record[]) => {
        RecordExportExcelButton.export(datas);
      });
    }
  }

  /** 查询 */
  private search(): Promise<Record[]> {
    return new Promise((resolve, reject) => {
      if (!this.rules()) {
        reject();
        return;
      }
      Load.startFullLoad('正在获取听课记录，请稍等。');
      listRecordApi(this.getParam()).then((result: any) => {
        const list: Record[] = Record.builds(result.list);
        resolve(list);
        Load.stopFullLoad();
      }).catch(() => {
        reject();
        Load.stopFullLoad();
      });
    });
  }

  /** 获取参数 */
  private getParam(): Record {
    const form: Record = Record.build(this.form);
    const page: Page = new Page();
    form.pageInfo = page;
    page.pageSize = 200000;
    return form;
  }

  /** 校验 */
  private rules(): boolean {
    let result: boolean = true;
    if (isNullOrUndefined(this.form.plan.supervisor.person.id) && isNullOrUndefined(this.form.plan.supervisor.supervisorGroup.id)) {
      this.createRuleFailNotify('未获取到督导信息，请稍后再试。');
      result = false;
    }
    return result;
  }

  /** 创建参数错误通知 */
  private createRuleFailNotify(message: string) {
    this.$notify.error({ title: '参数错误！', message });
  }
}
